import { render } from "./SbloccaColloConfirm.vue?vue&type=template&id=d527b71a&scoped=true"
import script from "./SbloccaColloConfirm.vue?vue&type=script&lang=js"
export * from "./SbloccaColloConfirm.vue?vue&type=script&lang=js"

import "./SbloccaColloConfirm.vue?vue&type=style&index=0&id=d527b71a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d527b71a"]])

export default __exports__